<p-menu #menu [model]="menuItems" [popup]="true" [appendTo]="'body'">
  <ng-template pTemplate="item" let-item>
    <div class="layout-item p-menuitem-content">
      <span
        class="layout-icon material-symbols-outlined"
        [ngClass]="{
          'rotate-right': item.rotate === 'right',
          'rotate-left': item.rotate === 'left',
          'rotate-top': item.rotate === 'top'
        }">
        {{ item.icon }}
      </span>
      <span class="p-menuitem-text">{{ item.label }}</span>
    </div>
  </ng-template>
</p-menu>
<button
  type="button"
  pButton
  pRipple
  (click)="menu.toggle($event)"
  pTooltip="Change Layout"
  tooltipPosition="bottom"
  class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
  <span class="material-symbols-outlined"> layers </span>
</button>
